import './types';
import { FormaRent } from './core/FormaRent';
import { readConfigFromScript } from './core/Config';
import { installHashLinks } from './features/hashLinks';
import { installDataButtons } from './features/dataButtons';
import { installAnalytics } from './features/analytics';
import { installBookingEvents } from './features/bookingEvents';
import { installCloseBridge } from './features/closeBridge';

if (!window.__FORMA_RENT_LOADED__) {
  window.__FORMA_RENT_LOADED__ = true;

  const instance = new FormaRent();
  window.FormaRent = instance;

  // Автоинициализация если <script data-forma-user="..."> или data-forma-owner
  // присутствует на странице. Без адресата init() бросит — не дёргаем, чтобы
  // интегратор мог вызвать init() вручную.
  const fromScript = readConfigFromScript();
  if (fromScript?.user || fromScript?.owner) {
    try {
      instance.init(fromScript);
      instance._registerCleanup(installHashLinks(instance));
      instance._registerCleanup(installDataButtons(instance));
      instance._registerCleanup(installAnalytics(instance));
      instance._registerCleanup(installBookingEvents(instance));
      instance._registerCleanup(installCloseBridge(instance));
    } catch (err) {
      console.error('[FormaRent] init failed:', err);
    }
  }
}
